import React from 'react';

import { search_page_path } from '../../routes';

const SEARCH_EXAMPLES = [
  'Most promising startups',
  'Artificial intelligence regulation',
  'The future of EV batteries',
  'Crypto & the SEC',
  'Venture capital trends',
];

const SearchExamples = () => (
  <div className="px-16">
    <div className="max-w-[600px] mx-auto mt-48">
      <h2 className="text-body-lg font-bold m-0 border-solid border-0 border-b border-gray-300">
        Example searches:
      </h2>
      <ul className="m-0 list-none mt-12 pl-4 space-y-8">
        {SEARCH_EXAMPLES.map((query) => (
          <li key={query}>
            <SearchExampleLink query={query} />
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const SearchExampleLink = ({ query }) => (
  <a href={search_page_path({ query })} className="hover:text-primary-red transition-colors m-0">
    <span aria-hidden="true">{'> '}</span>
    <span className="sr-only">Search results for </span>
    <span className="text-body-sm italic">{query}</span>
  </a>
);

export default SearchExamples;
